<!--
 * @Author: Shen Kui
 * @Description: 对象信息
-->
<template>
  <div>
    <el-tooltip
      :content="showBitComponent ? '收缩位号基本信息' : '展开位号基本信息'"
      placement="right"
      :open-delay="1000"
    >
      <div
        class="icon-expand-site-basic position-absolute text-white cur_pointer flex-align-center d-flex flex-row-center"
        :class="showBitComponent || hoverIn ? 'icon_selected' : ''"
        @click="showBitComponent = !showBitComponent"
        @mouseenter="hoverIn = true"
        @mouseleave="hoverIn = false"
      >
        <span
          v-if="showBitComponent || hoverIn"
          class="iconfont text-12px text-white icon-yxr-zl"
        ></span>
        <span
          class="iconfont icon-bg-setup"
          :class="showBitComponent || hoverIn ? 'text-18px' : 'text-20px'"
        ></span>
      </div>
    </el-tooltip>
    <div
      class="position-absolute p-10px component-container"
      id="tag-attribute"
      v-show="showBitComponent"
    >
      <div
        class="card-title text-hex-fff text-24px h-52px w-full bg-no-repeat flex items-center pt-10px px-10px"
      >
        对象信息
      </div>
      <el-tabs v-model="activeComponents" stretch class="w-full my-20px tabs-distribution">
        <el-tab-pane label="属性" name="Attribute"></el-tab-pane>
        <el-tab-pane label="关联文档" name="DocRelational"></el-tab-pane>
        <el-tab-pane label="关联对象" name="TagRelational"></el-tab-pane>
      </el-tabs>
      <el-card
        class="tree-card w-full h-[calc(100%-150px)] mt-10px overflow-y-auto"
        :body-style="{ padding: '10px', height: '100%' }"
      >
        <!-- 属性 -->
        <div class="w-full h-full attribute" v-show="activeComponents === 'Attribute'">
          <div class="flex justify-start item-start mb-10px">
            <span class="text-16px text-white custom-shadow ml-4px"> 基本属性 </span>
          </div>
          <div
            class="mb-10px text-white border-2px p-10px rounded-5px border-[#409eff]"
            v-if="basicAttributes.length > 0"
          >
            <div
              class="flex text-12px leading-24px"
              v-for="(item, index) in basicAttributes"
              :key="index"
            >
              <div class="text-[#c3c3c3]">{{ item.name }}：</div>
              <el-tooltip
                :content="item.value"
                placement="top"
                :open-delay="500"
                :disabled="!item.value"
              >
                <div class="flex-1 truncate">{{ tagBasicAttrForm[item.value] }}</div>
              </el-tooltip>
            </div>
          </div>
          <div class="flex justify-start item-start mb-10px" v-if="!_.isEmpty(generalAttribute)">
            <img src="../../../../resource/assets/images/titleIcon.png" alt="" />
            <span class="text-16px text-white custom-shadow ml-4px">
              {{ generalClassInfo.name }}
            </span>
          </div>
          <div
            class="mb-10px text-white border-2px p-10px rounded-5px border-[#409eff]"
            v-if="generalAttribute.length > 0"
          >
            <div
              class="flex text-14px leading-24px"
              v-for="(item, index) in generalAttribute"
              :key="index"
            >
              <div class="text-[#c3c3c3]">{{ item.attrbuteDetail.name }}：</div>
              <el-tooltip
                :content="item.value"
                placement="top"
                :open-delay="500"
                :disabled="!item.value"
              >
                <div class="flex-1 truncate">{{ item.attrValue }}</div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <!-- 关联对象 -->
        <div
          class="w-full tag-relational h-full overflow-y-auto"
          v-show="activeComponents === 'TagRelational'"
        >
          <div v-for="(item, index) in tagRelationalDatas" :key="index">
            <div class="flex justify-start item-start mb-10px">
              <img src="../../../assets/images/titleIcon.png" alt="" />
              <span class="text-16px text-white custom-shadow ml-4px"> {{ item.nodeName }} </span>
            </div>
            <div
              v-if="item.childrenNodes.length > 0"
              class="mb-10px text-white border-2px p-10px rounded-5px border-[#409eff] text-12px"
            >
              <div class="flex" v-for="(cItem, cIndex) in item.childrenNodes" :key="cIndex">
                <el-tooltip
                  :content="`${cItem.nodeName}[${cItem.nodeCode}]`"
                  placement="top"
                  :open-delay="500"
                >
                  <div class="flex-1 truncate leading-24px">
                    {{ cItem.nodeName }}[{{ cItem.nodeCode }}]
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
          <!-- <VirtualTree
            default-expand-all
            :highlight-current="true"
            :data="tagRelationalDatas"
            :props="defaultTreeProps"
            :treeStyle="
              heightObj.isZoom
                ? {
                    maxHeight: `calc(${heightObj.maxHeight} - 20px)`,
                    minHeight: `calc(${heightObj.minHeight} - 20px)`,
                    overflowY: 'auto',
                  }
                : {
                    maxHeight: `calc(${heightObj.maxHeight} - 50px)`,
                    minHeight: `calc(${heightObj.minHeight} - 50px)`,
                    overflowY: 'auto',
                  }
            "
            class="w-full"
            emptyText="暂无数据"
            accordion
            @node-click="clickRelationalCode"
            :expand-on-click-node="false"
          >
            <div
              class="custom-tree-node text-overflow w-full d-flex flex-align-center"
              slot-scope="{ node, data }"
            >
              <el-tooltip
                :content="`${data.nodeName}${data.nodeCode ? `[${data.nodeCode}]` : ''}`"
                placement="top"
                :open-delay="1000"
              >
                <span v-if="data.nodeCode !== null" class="text-overflow tree-text-label text-12px"
                  >{{ data.nodeName }} [{{ data.nodeCode }}]</span
                >
                <span v-else class="text-overflow tree-text-label text-12px">{{
                  data.nodeName
                }}</span>
              </el-tooltip>
            </div>
          </VirtualTree> -->
        </div>
        <!-- 关联文档 -->
        <div
          class="w-full document h-full overflow-y-auto"
          v-show="activeComponents === 'DocRelational'"
        >
          <div v-for="(item, index) in tagDocumentFiles" :key="index">
            <div class="flex justify-start item-start mb-10px">
              <img src="../../../assets/images/titleIcon.png" alt="" />
              <span class="text-16px text-white custom-shadow ml-4px"> {{ item.nodeName }} </span>
            </div>
            <div
              class="mb-10px text-white border-2px p-10px rounded-5px border-[#409eff] text-12px"
            >
              <div class="flex" v-for="(cItem, cIndex) in item.childrenNodes" :key="cIndex">
                <el-tooltip :content="cItem.fileName" placement="top" :open-delay="500">
                  <div class="flex-1 truncate leading-24px">{{ cItem.fileName }}</div>
                </el-tooltip>
                <div class="flex">
                  <el-tooltip content="弹窗" placement="top" :open-delay="500">
                    <img
                      class="cursor-pointer"
                      src="../../../assets/images/dialog.png"
                      alt=""
                      @click="viewMore(cItem)"
                    />
                  </el-tooltip>
                  <!-- <el-tooltip content="侧边弹窗" placement="top" :open-delay="500">
                    <img
                      class="cursor-pointer"
                      src="../../../assets/images/split_screen.png"
                      alt=""
                      @click="rightDialog(cItem)"
                    />
                  </el-tooltip> -->
                  <el-tooltip class="ml-2px" content="分屏" placement="top" :open-delay="500">
                    <img
                      class="cursor-pointer"
                      src="../../../assets/images/split.png"
                      alt=""
                      @click="splitScreen(cItem)"
                    />
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
          <!-- <VirtualTree
            default-expand-all
            emptyText="暂无数据"
            :highlight-current="true"
            :data="tagDocumentFiles"
            :props="defaultTagDocProps"
            :treeStyle="
              heightObj.isZoom
                ? {
                    maxHeight: `calc(${heightObj.maxHeight} - 20px)`,
                    minHeight: `calc(${heightObj.minHeight} - 20px)`,
                    overflowY: 'auto',
                  }
                : {
                    maxHeight: `calc(${heightObj.maxHeight} - 50px)`,
                    minHeight: `calc(${heightObj.minHeight} - 50px)`,
                    overflowY: 'auto',
                  }
            "
            accordion
          >
            <div
              class="custom-tree-node text-overflow w-full d-flex flex-align-center h-32px flex"
              slot-scope="{ node, data }"
            >
              <el-tooltip
                :content="`${node.label}${data.documentName ? `[${data.documentName}]` : ''}`"
                placement="top"
                :open-delay="1000"
              >
                <div
                  v-if="data.documentName"
                  class="text-overflow tree-text-label text-12px h-32px leading-32px flex-1"
                  style="line-height: 32px"
                >
                  {{ node.label }} [{{ data.documentName }}]
                </div>
                <div
                  v-else
                  class="tree-text-label text-overflow text-12px h-32px leading-32px flex-1"
                  style="line-height: 32px"
                >
                  {{ node.label }}
                </div>
              </el-tooltip>
              <div v-if="!node.childNodes.length" class="text-overflow h-32px tc w-60px">
                <el-tooltip content="预览" placement="top" :open-delay="1000">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="viewMore(node)"
                    class="iconfont icon-line-show"
                  ></el-button>
                </el-tooltip>
                <el-button size="mini" @click="splitScreen(data)">分屏</el-button>
              </div>
            </div>
          </VirtualTree> -->
        </div>
      </el-card>
    </div>
    <!-- 文件预览 -->
    <el-dialog
      ref="centerDialog"
      :title="`${previewFileName}`"
      :visible.sync="centerDialogVisible"
      :modal="false"
      :close-on-click-modal="false"
      :custom-class="isShowCustomClass ? 'custom-dialog' : ''"
      @close="closeDialog"
      v-dialogDrag
    >
      <img
        :src="previewVersionTag === 0 ? 'static/img/gz/在用.png' : 'static/img/gz/弃用.png'"
        alt
        v-if="versionManagement === 'true'"
        class="position-absolute"
        style="right: 10px; top: 65px"
      />
      <!-- 图片预览 -->
      <div
        class="w-full h-full flex justify-center"
        v-if="imgTypeList.includes(previewSvgType.toLowerCase())"
      >
        <img v-move :src="resourceUrl" id="splitImg" class="h-[calc(100% - 100px)]" />
      </div>
      <p v-if="previewSvgType === 'pdf'" class="height-20 text-14px has-text-right text-color-blue">
        操作提示：Ctrl + 鼠标滚轮中键 可放大缩小
      </p>
      <iframe
        v-if="previewSvgType === 'wizdrawing' && showIframe"
        ref="htFrame"
        :src="htPage"
        width="100%"
        height="100%"
        class="myiframe"
        allowfullscreen
        @load="htLoad"
      ></iframe>
      <!-- pdf预览 -->
      <iframe
        v-else-if="showIframe && previewSvgType === 'pdf'"
        width="100%"
        height="100%"
        allow="autoplay"
        class="myiframe"
        allowfullscreen
        :src="`/lib/pdfjs/web/viewer.html?file=${resourceUrl}`"
      ></iframe>
      <!-- svg预览 -->
      <iframe
        width="100%"
        height="100%"
        v-else-if="showIframe && previewSvgType === 'svg'"
        id="previewSvg"
        :src="`/lib/svgView/index.html?file=${previewSvgUrl}`"
      ></iframe>
      <!-- 其他文件预览 -->
      <iframe
        :src="resourceUrl"
        width="100%"
        height="100%"
        v-else-if="
          showIframe &&
            !['svg', 'pdf'].includes(previewSvgType) &&
            !imgTypeList.includes(previewSvgType.toLowerCase())
        "
        allowfullscreen
        allow="autoplay"
        class="myiframe"
      ></iframe>
      <iframe
        width="100%"
        height="100%"
        v-else-if="(previewSvgType === 'pr' || previewSvgType === 'pprj') && showIframe"
        id="previewSvg"
        :src="resourceUrl"
      ></iframe>
    </el-dialog>
  </div>
</template>
<script>
import DocumentService from '@/services/DocumentService'
import VirtualTree from '@/components/virtualScrollTree/tree'
import ApiMixinTagObjectBrowse from '@/assets/js/api/tagObjectBrowse'

export default {
  mixins: [ApiMixinTagObjectBrowse],
  name: 'bitRelational',
  components: {
    VirtualTree,
  },
  props: {
    tagCode: {
      type: String,
      default: '',
    },
    tagId: {
      type: String,
      default: '',
    },
    isTag: {
      type: Boolean,
      default: false,
    },
    fileId: {
      type: String,
      default: '',
    },
    heightObj: {
      type: Object,
      default: () => {
        return {
          minHeight: '',
          maxHeight: '',
          isZoom: false,
        }
      },
    },
  },
  data() {
    return {
      hoverIn: false,
      currentModel: '',
      // 关联位号目录树的配置项
      defaultTreeProps: {
        label: (data) => {
          if (data.nodeCode) {
            return `${data.nodeCode}[${data.nodeName}]`
          }
          return data.nodeName
        },
        children: 'childrenNodes',
      },
      // 关联文档配置
      defaultTagDocProps: {
        label: (data) => {
          if (data.documentName) {
            return `${data.nodeName}[${data.documentName}]`
          }
          return data.nodeName
        },
        children: 'childrenNodes',
      },
      activeComponents: 'Attribute', // 当前显示的组件
      showBitComponent: true, // 显示位号基本信息组件
      collapseActiveName: ['baseAttr', 'currencyAttr'], // 折叠面板绑定值
      templateAttrSetList: [],
      generalAttribute: [],
      generalClassInfo: {},
      generalAttributeIndex: -1,
      tagRelationalDatas: [],
      tagDocumentFiles: [],
      // 位号基本属性
      tagBasicAttrForm: {
        tagParentName: '',
        code: '',
        name: '',
        shortDescription: '',
        longDescription: '',
        tagclassname: '',
      },
      previewFileName: '',
      centerDialogVisible: false,
      previewVersionTag: 0,
      previewSvgType: '',
      htPage: `${window.location.origin}/static/ht/htView.html`, // ht预览页面路径
      htTimer: null,
      resourceUrl: '',
      showIframe: false,
      previewSvgUrl: '', // svg文件路径
      systemParams: localStorage.getItem('systemParams')
        ? JSON.parse(localStorage.getItem('systemParams'))
        : [],
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      imgTypeList: ['bmp', 'jpg', 'jpeg', 'png', 'gif', 'webp'],
      basicAttributes: [
        { name: '上级名称', value: 'parentName' },
        { name: '代码', value: 'code' },
        { name: '名称', value: 'name' },
        { name: '类别', value: 'className' },
        { name: '短描述', value: 'shortDescription' },
        { name: '长描述', value: 'longDescription' },
      ],
      splitShow: false, // 分屏显示
      isShowCustomClass: false,
    }
  },
  computed: {
    // 项目信息
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    // 通用属性是否显示
    isShowBaseAttr() {
      return _.every(this.generalAttribute, (item) => {
        return _.isNil(item.value)
      })
    },
    DisplayNoDataAttribute() {
      const DisplayNoDataAttribute =
        _.find(this.systemParams, { parameterCode: 'DisplayNoDataAttribute' }) || {}
      return DisplayNoDataAttribute.parameterValue || 'true'
    },
    versionManagement() {
      const version = _.find(this.systemParams, { parameterCode: 'versionManagement' }) || {}
      return version.parameterValue
    },
    // 兼容除saas其他项目使用该模块
    basePath() {
      const routerBase = _.get(Wiz, 'globalSettings.globalConfig.routerBase')
      if (!routerBase) {
        return ''
        // eslint-disable-next-line no-else-return
      } else if (routerBase && Array.isArray(routerBase)) {
        return routerBase.length ? `/${routerBase[0]}` : ''
      }
      return `/${routerBase}`
    },
    isVersion() {
      return this.$route.query.isVersion
    },
  },
  watch: {
    tagCode(val) {
      if (this.showBitComponent && val) {
        this.$nextTick(() => {
          if (this.fileId) {
            this.getAttributeInfo(this.tagId)
          }
        })
      }
    },
    resourceUrl() {
      this.showIframe = false
      this.$nextTick(() => {
        this.showIframe = true
      })
    },
    /**
     * @description: 用于控制组件的高度
     * @param {*} bol
     * @return {*}
     */

    showBitComponent(bol) {
      if (bol && this.tagCode && this.fileId) {
        this.getAttributeInfo(this.tagId)
      }
      this.$emit('showBit', bol)
    },
  },
  async mounted() {
    // 监听svg的单击事件，与三维联动
    window.addEventListener('message', (el) => {
      if (el.data.type === 'svgTrigger') {
        if (el.data.tagId) {
          this.getAttributeInfo(el.data.tagId)
        }
        if (el.data.code) {
          this.$emit('getModelData', { code: el.data.code, businessId: el.data.tagId })
          this.$emit('setObjectNode', { businessId: el.data.tagId, code: el.data.code })
          // this.$emit('getModelData', { code: '011MYA01UH001' }) // 临时代码，用于测试
        }
      }
    })
  },
  methods: {
    // ht加载
    htLoad() {
      const $window = this.$refs.htFrame.contentWindow
      $window.init(this.resourceUrl)
      if (this.currentEnv.VUE_APP_CURRENT_PROJECT === 'GZ') {
        setTimeout(() => {
          $window.setColorChange()
        }, 500)
        this.htTimer = setInterval(() => {
          $window.setColorChange()
        }, 8000)
      }
    },
    // 关联文档树结构预览
    async viewMore(data) {
      this.previewSvgType = _.last(_.split(data.fileName, '.')).toLowerCase()
      if (this.previewSvgType !== 'pr' && this.previewSvgType !== 'pprj') {
        if (this.previewSvgType === 'wizdrawing') {
          const fileRes = await DocumentService.findFileUrl({
            id: data.md5,
          })
          if (fileRes) {
            this.resourceUrl = fileRes
          }
        } else {
          this.resourceUrl = `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${data.fileId}`
        }
        this.previewFileName = data.fileName
        this.previewVersionTag = data.versionTag
        if (this.previewSvgType === 'svg') {
          this.previewSvgUrl = this.resourceUrl
          window.svgIframeId = 'previewSvg'
          window.svgFileId = data.fileId
        }
        // const res = await DocumentService.findDocAttr({
        //   id: data.data.documentId,
        //   standardId: localStorage.getItem('standardId') || '',
        // })
        // if (res && res.data) {
        //   if (this.previewSvgType === 'svg') {
        //     this.previewSvgUrl = this.resourceUrl
        //     window.svgIframeId = 'previewSvg'
        //     window.svgFileId = data.data.fileId
        //   }
        //   this.previewVersionTag = res.data.versionTag
        // }
        this.centerDialogVisible = true
      } else {
        // 云渲染跳转新页面预览
        // window.open(`/#/modelDocView?documentId=${data.data.documentId}`)
        const fullScreenParam = this.basePath
          ? {
              ShowClassicTop: false,
              ShowClassicLeft: false,
            }
          : {}
        window.routerTrigger = 'noCache'
        // // 云渲染全屏版本
        const routerData = this.$router.resolve({
          path: `${this.basePath}/fullscreen/model-doc-view${
            Wiz.globalSettings.dynamicModules.modules['legacy-resource']?.config?.isVulkan
              ? '-vk'
              : ''
          }/index`,
          query: {
            documentId: `${data.documentId}`,
            title: encodeURIComponent(data.nodeCode),
            standardId: localStorage.getItem('standardId') || '',
            classId: this.$route.query.classId || '',
            isVersion: this.isVersion, // 是否是历史版本查看
            token: localStorage.getItem('authorization'),
            withoutRelation: 1,
            ...fullScreenParam,
          },
        })
        console.log('routerData.href_____________', routerData.href)
        this.resourceUrl = routerData.href
        // window.open(routerData.href, '_blank')
        this.centerDialogVisible = true
      }
    },
    // 点击关联位号
    clickRelationalCode(data) {
      if (data.nodeCode) {
        this.$emit('currentCodeChange', data.nodeCode)
      }
    },
    // 右侧弹框
    rightDialog(item) {
      this.viewMore(item)
      this.isShowCustomClass = true
    },
    closeDialog() {
      this.isShowCustomClass = false
    },
    // 分屏查看文件
    async splitScreen(data) {
      const fileType = _.last(_.split(data.fileName, '.')).toLowerCase()
      this.$emit('splitScreen', { ...data, type: fileType })
    },
    // 获取基本属性
    async getBaseInfo(tagId) {
      this.tagBasicAttrForm = this.$options.data().tagBasicAttrForm
      this.generalAttribute = []
      if (!tagId || !this.isTag) return
      const res = await this.apiTags({
        method: 'list',
        params: {
          id: tagId,
          standardId: localStorage.getItem('standardId') || '',
        },
      })
      if (res && res.code === 0 && res.data) {
        this.tagBasicAttrForm = res.data.tag
        this.generalAttribute = res.data.classAndAttributes?.attributes || []
        this.generalClassInfo = res.data.classAndAttributes?.classInfo || {}
      }
    },
    // 获取关联位号树的数据
    async numTreeData(tagId) {
      this.tagRelationalDatas = []
      if (!this.tagId || !this.isTag) return
      const res = await this.apiTags({
        method: 'docRelationTag',
        params: {
          id: tagId,
          standardId: localStorage.getItem('standardId') || '',
        },
      })
      if (res && res.data && res.code === 0) {
        this.tagRelationalDatas = res.data
      }
    },
    // 获取关联文档树的数据
    async documentTreeData(tagId) {
      this.tagDocumentFiles = []
      if (!this.tagId || !this.isTag) return
      const res = await this.apiTags({
        method: 'docRelationFile',
        params: {
          id: tagId,
          standardId: localStorage.getItem('standardId') || '',
        },
      })
      if (res && res.data && res.code === 0) {
        this.tagDocumentFiles = res.data
      }
    },
    // 获取位号信息
    async getAttributeInfo(tagId) {
      this.getBaseInfo(tagId)
      this.numTreeData(tagId)
      this.documentTreeData(tagId)
      // this.collapseActiveName = this.$options.data().collapseActiveName
      // const res = await DocumentService.findTagByFile({
      //   site_id: this.currentProject.id,
      //   code: this.tagCode,
      //   file_id: this.fileId,
      // })
      // if (res && res.code === 0 && _.keys(res.data).length) {
      //   this.templateAttrSetList = _.filter(res.data.templateAttribute, (item) => {
      //     const index = _.findIndex(item.attributeList, (attribute) => {
      //       return attribute.value
      //     })
      //     return index !== -1 || this.DisplayNoDataAttribute === 'true'
      //   })
      //   const collapseLabel = _.map(
      //     _.filter(res.data.templateAttribute, (item) => {
      //       return !_.isEmpty(item.attributeList)
      //     }),
      //     (el) => {
      //       return el.name
      //     }
      //   )
      //   this.collapseActiveName.push(...collapseLabel)
      //   this.tagRelationalDatas = _.map(res.data.associatedTagList, (v) => {
      //     return {
      //       name: v.type,
      //       relation: _.isArray(v.relation) ? v.relation : !_.isNil(v.relation) ? [v.relation] : [],
      //     }
      //   })
      //   this.generalAttribute = res.data.generalAttribute
      //   // 判断通用属性是否全无值
      //   this.generalAttributeIndex = _.findIndex(this.generalAttribute, (item) => {
      //     return item.value
      //   })
      //   this.tagDocumentFiles = _.map(res.data.documentClass, (val) => {
      //     return {
      //       fileName: val.name,
      //       documenFileList: val.documenFileList,
      //       fileId: val.id,
      //     }
      //   })
      //   // 拿到返回值赋值给基本属性表单
      //   // this.tagBasicAttrForm = res.data.tag
      // } else {
      //   this.templateAttrSetList = []
      //   this.generalAttribute = []
      //   this.tagRelationalDatas = []
      //   this.tagDocumentFiles = []
      //   // 拿到返回值赋值给基本属性表单
      //   this.tagBasicAttrForm = this.$options.data().tagBasicAttrForm
      // }
    },
    /**
     * @description: 切换当前组件
     * @param {*} type 当前显示的组件
     * @return {*}
     */

    // 切换当前组件
    switchComponents(type) {
      this.activeComponents = type
    },

    // 清空所有数据
    clearAllData() {
      // 清除基本属性数据
      this.tagBasicAttrForm = {
        tagParentName: '',
        code: '',
        name: '',
        shortDescription: '',
        longDescription: '',
        tagclassname: '',
      }

      // 清除通用属性数据
      this.generalAttribute = []
      this.generalClassInfo = {}

      // 清除关联位号数据
      this.tagRelationalDatas = []

      // 清除关联文档数据
      this.tagDocumentFiles = []

      // 清除模板属性数据
      this.templateAttrSetList = []

      // 重置预览相关数据
      this.previewFileName = ''
      this.centerDialogVisible = false
      this.previewVersionTag = 0
      this.previewSvgType = ''
      this.resourceUrl = ''
      this.showIframe = false
      this.previewSvgUrl = ''
      this.bitModelCode = ''
      // 重置折叠面板
      this.collapseActiveName = ['baseAttr', 'currencyAttr']

      // 清除定时器
      if (this.htTimer) {
        clearInterval(this.htTimer)
        this.htTimer = null
      }
    },
  },
}
</script>

<style lang="scss" scoped>

@import '../css/index.scss';
.component-container {
  width: 368px;
  height: calc(100% - 140px);
  right: 35px;
  top: 66px;
  z-index: 100;
  background-image: url('../../../../resource/assets/images/container_bg.png');
  background-size: 100% 100%;
}
.card-title {
  width: 100%;
  height: 46px;
  background-size: 100% 100%;
}
.active-color {
  background-color: #00c0ff !important;
}
.button-color {
  border: none !important;
  background-color: rgba(255, 255, 255, 0.4) !important;
}
.tree-card {
  background-color: transparent !important;
  border: none !important;
  overflow-y: auto;
}
/deep/ .el-tree-node__content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-checkbox {
  font-size: 12px;
  color: #fff;
}

.collapse-text {
  padding: 10px;
  color: #ffffff;
}
.text-title {
  width: 90px;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.w-15 {
  width: 15px;
}
.icon-expand-site-basic {
  top: 66px;
  right: 0;
  z-index: 990;
  width: 34px;
  height: 34px;
  border-radius: 5px 2px 2px 5px;
  background-color: rgba(0, 116, 201, 0.8);
}
.tree-text-label {
  width: 200px;
}
/deep/.el-dialog__headerbtn .el-dialog__close {
  color: #fff !important;
}
.collapse_title {
  text-overflow: ellipsis;
}
.icon_selected {
  background-color: #00c0ff !important;
}
.position-absolute {
  position: absolute;
}
.flex-row-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.el-card__body {
  background-color: transparent !important;
}
.ell,
.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/deep/.el-tabs {
  width: 100%;
  height: 48px;
  line-height: 48px;
  background-size: 100% 100%;
  background: #1e6fb5;
}
/deep/.el-tabs__nav-wrap:after {
  background-color: transparent !important;
}
/deep/.el-tabs__item.is-active {
  background-color: transparent !important;
}
/deep/.el-tabs__nav.is-stretch {
  height: 44px !important;
  align-items: center;
}
/deep/.el-tabs__active-bar {
  width: 82px !important;
  height: 3px !important;
  background-color: #409eff !important;
}
/deep/.el-card.is-always-shadow {
  box-shadow: none !important;
}
/deep/.el-dialog__wrapper {
  pointer-events: none;
}
/deep/.custom-dialog {
  position: fixed !important;
  left: auto !important;
  right: 0 !important;
}
/deep/.el-dialog {
  width: 1000px !important;
  height: 672px !important;
  background-image: url('../../../../resource/assets/images/container_bg.png') !important;
  background-size: 100% 100% !important;
  background-color: transparent !important;
  pointer-events: auto !important;
}
/deep/.el-dialog__title {
  line-height: 45px !important;
}

</style>
